export const buyers = [
  { name: 'María González', country: 'Mexico', minutesAgo: 2 },
  { name: 'Lucía Fernández', country: 'Argentina', minutesAgo: 4 },
  { name: 'Carmen Rodríguez', country: 'Spain', minutesAgo: 6 },
  { name: 'Valentina Rojas', country: 'Chile', minutesAgo: 3 },
  { name: 'Sofía Ramírez', country: 'Colombia', minutesAgo: 8 },
  { name: 'Ana Torres', country: 'Peru', minutesAgo: 5 },
  { name: 'Gabriela Méndez', country: 'Guatemala', minutesAgo: 7 },
  { name: 'Isabel Castillo', country: 'Dominican Republic', minutesAgo: 1 },
  { name: 'Daniela Vargas', country: 'Costa Rica', minutesAgo: 9 },
  { name: 'Patricia Morales', country: 'Ecuador', minutesAgo: 4 },
  { name: 'Rosa Herrera', country: 'Uruguay', minutesAgo: 6 },
  { name: 'Camila Núñez', country: 'Puerto Rico', minutesAgo: 3 },
];
